import { atom } from 'jotai'

import { AwardsFile } from 'types/AwardsFile'

export interface IModalsAtom {
  isOpen: boolean
  award?: AwardsFile
  slug?: string
}

export const ModalAtom = atom<IModalsAtom>({
  isOpen: false,
  award: undefined,
  slug: '',
})
